module.exports = __webpack_public_path__ + "static/img/logo55.8986f28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo55.png
// module id = P5kp
// module chunks = 1